// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"b3daf0cb","62":"a440a598","107":"66137f17","184":"3d383459","256":"f308cae8","430":"e0798a6b","754":"0dce38dd","833":"12da7ad5","931":"8976ce5e","982":"22a5e880"}[chunkId] + ".chunk.js";
};